import React from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { IconWarning } from '@contrast-security-inc/design-system-foundations'
import {
  Tooltip,
  TooltipProps
} from '@contrast-security-inc/design-system-popovers'

export const appInstrumentationTooltipTestId =
  'app-instrumentation-tooltip-test-id'

export interface AppInstrumentationTooltipProps {
  applicationName: string
  placement?: TooltipProps['placement']
}

export function AppInstrumentationTooltip({
  applicationName,
  placement
}: AppInstrumentationTooltipProps) {
  return (
    <Tooltip
      placement={placement}
      body={
        <AppInstrumentationTooltipContent applicationName={applicationName} />
      }
    >
      <IconWarning
        className={css`
          margin-left: 5px;
        `}
        data-e2e="app-instrumentation-conflict-tooltip"
        testId={appInstrumentationTooltipTestId}
        size="sm"
        color="red50"
      />
    </Tooltip>
  )
}

export function AppInstrumentationTooltipContent({
  applicationName
}: AppInstrumentationTooltipProps) {
  return (
    <div
      className={css`
        max-width: 250px;
        white-space: normal;
      `}
    >
      <FormattedMessage
        id="variable_instrumentationConflict_tooltipContent"
        values={{ applicationName }}
      />
    </div>
  )
}
